/**
 * Guarda en el equipo del usuario un archivo descargado de la API, tal cual (el cliente no lo construye ni
 * lo interpreta). El enlace temporal se libera al terminar.
 */
export function saveBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
